import {AfterContentInit, Component, EventEmitter, Inject, ViewChild} from '@angular/core';
import {CommonModule, NgFor} from "@angular/common";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatPaginator, MatPaginatorModule} from "@angular/material/paginator";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatOptionModule} from "@angular/material/core";
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  CdkDropListGroup,
  moveItemInArray,
  transferArrayItem
} from "@angular/cdk/drag-drop";
import {HttpService} from "../../services/http/http.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'associazioni-dialog',
  templateUrl: './associazioni-dialog.component.html',
  styleUrls: ['./associazioni-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatTooltipModule, MatPaginatorModule, MatDialogModule, MatAutocompleteModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule, MatOptionModule, CdkDropListGroup, CdkDropList, NgFor, CdkDrag],
})
export class AssociazioniDialog implements AfterContentInit {
  constructor(
    public dialogRef: MatDialogRef<AssociazioniDialog>,
    public api: HttpService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  onAddClick = new EventEmitter();
  onSaveClick = new EventEmitter();
  filteredLista: any;
  filteredListaAssociate: any;
  searchText: string;
  searchTextAssociate: string;
  title: string;
  ngAfterContentInit(): void {


    this.filteredLista = this.data.lista;
    this.filteredListaAssociate = this.data.associate;
    this.title = this.data.tipo;
  }

  startSearch() {
    let event = {
      pageIndex:0,
      pageSize:25
    }

    this.onPaginateChange(event);
  }

  onPaginateChange(event: any) {

    if (this.data.tipo === 'competenze' && this.data.isAssemblea == 'gestioneAssemblea'){
      this.api.getRicercaCompetenzeValidateDaAssociare({'descrizione':this.searchText}, event.pageIndex, event.pageSize).subscribe({
        next: (response: any) => {
          this.data.count = response.result.count;
          let listaCompetenze = response.result.listaCompetenze
          if (listaCompetenze.length == 0) {
            this.snackBar.open('Nessuna competenza trovata', 'close', { panelClass: 'errorSnack' });
          }
          this.filteredLista = listaCompetenze.filter((o1: { id: any; }) => {

            return !this.filteredListaAssociate.some(function (o2: { id: any; }) {
              return o1.id === o2.id;          // assumes unique id
            });
          });
        }
      });
    }else if (this.data.tipo == 'competenze') {
      this.api.getRicercaCompetenzeDaAssociare({'descrizione':this.searchText}, event.pageIndex, event.pageSize).subscribe({
        next: (response: any) => {
          this.data.count = response.result.count;
          let listaCompetenze = response.result.listaCompetenze
          if (listaCompetenze.length == 0) {
            this.snackBar.open('Nessuna competenza trovata', 'close', { panelClass: 'errorSnack' });
          }
          this.filteredLista = listaCompetenze.filter((o1: { id: any; }) => {

            return !this.filteredListaAssociate.some(function (o2: { id: any; }) {
              return o1.id === o2.id;          // assumes unique id
            });
          });
        }
      });
    }else if (this.data.tipo == 'conoscenze') {
      const idsToExclude = this.filteredListaAssociate.map((el : any) => el.id);
      this.api.ricercaConoscenze({'descrizione':this.searchText, idsToExclude}, event.pageIndex, event.pageSize).subscribe({
        next: (response: any) => {
          this.data.count = response.result.count;
          this.filteredLista = response.result.listaConoscenze
          if (this.filteredLista.length === 0) {

            this.snackBar.open('Nessuna conoscenza trovata', 'close', { panelClass: 'errorSnack' });
          }
        }
      });
    }else if (this.data.tipo == 'abilita') {
      this.api.ricercaAbilita({'descrizione':this.searchText}, event.pageIndex, event.pageSize).subscribe({
        next: (response: any) => {
          this.data.count = response.result.count;
          let listaAbilita = response.result.listaAbilita

          if (listaAbilita.length === 0) {

            this.snackBar.open('Nessuna abilità trovata', 'close', { panelClass: 'errorSnack' });
          }

          this.filteredLista = listaAbilita.filter((o1: { id: any; }) => {

            return !this.filteredListaAssociate.some(function (o2: { id: any; }) {
              return o1.id === o2.id;          // assumes unique id
            });
          });
        }
      });
    }else if (this.data.tipo == 'profili') {
      this.api.ricercaProfiliValidati({'descrizione':this.searchText}, event.pageIndex, event.pageSize).subscribe({
        next: (response: any) => {
          this.data.count = response.result.count;
          let listaProfili = response.result.listaProfili
          this.filteredLista = listaProfili.filter((o1: { idProfilo: any; }) => {
            return !this.filteredListaAssociate.some(function (o2: { idProfilo: any; }) {
              return o1.idProfilo === o2.idProfilo;          // assumes unique id
            });
          });
        }
      });
    }

  }

  save(): any {
    this.onSaveClick.emit(this.data);
  }


  competenzaDetail(event: any) {

    this.onAddClick.emit(event);
  }


  aggiungiCompetenza(title : string) {
    const sectionName = title === 'profili' ? 'gestioneProfiloProfessionale' : 'gestioneCompetenze';
    const type = this.data.tipo == 'conoscenze' || this.data.tipo == 'abilita' ? this.data.tipo : 'new';
    const evt = {
      type,
      sectionName,
      isProfilo : true,
      descrizioneCompetenza : this.searchText
    };
    this.onAddClick.emit(evt);

  }

  filterList(event: any) {
    if (event.target) { }

    this.filteredLista = this.data.lista.filter((item: { [x: string]: any; }) => {
      return Object.keys(item).some(key => {
        return String(item[key]).toLowerCase().includes(this.searchText.toLowerCase());
      });
    });
  }

  filterListAssociate(event: any) {

    this.filteredListaAssociate = this.data.associate.filter((item: { [x: string]: any; }) => {
      return Object.keys(item).some(key => {
        return String(item[key]).toLowerCase().includes(this.searchTextAssociate.toLowerCase());
      });
    });
  }



  drop(event: CdkDragDrop<string[]>) {
    let idx = event.container.data.indexOf(event.previousContainer.data[event.previousIndex]);
    if (idx != -1) {
      return;//if item exist
    }


    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  associaTutti() {
    this.data.associate = [...this.filteredLista, ...this.data.associate];
    this.data.lista = [];
    this.filteredLista = this.data.lista;

    this.searchTextAssociate = '';
    this.filteredListaAssociate = this.data.associate;
  }

  disassociaTutti() {
    this.data.lista = [...this.data.associate, ...this.data.lista];
    this.data.associate = [];
    this.filteredLista = this.data.lista;

    this.searchTextAssociate = '';
    this.filteredListaAssociate = this.data.associate;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  showAlert() {
    // alert('click su icona!')
  }

}
